export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',

  address: '上海市徐汇区普天信息产业园A7栋709室',
  uc_host: 'https://fagao.0925.ren',
  site_host: 'https://0925.ren',
  chat_url: 'javascript:window.open(\'https://wpa.qq.com/msgrd?v=3&uin=695452366&site=qq&menu=yes\', \'_blank\', \'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no\');',
  special_url: '/',
  site_title: '零玖贰伍 ',
  welcome_title: '零玖贰伍 ',
  site_short_title: '祥文网络',
  site_subtitle: '',
  company_name: '祥文网络',
  copyright: '© 2022 祥文网络',
  logo: '/static/images/logo.png',
  logo_cn: '/static/images/logo_cn.png',
  favicon: '/static/images/favicon.ico',
  payment: '',
  qq: '2279099005',
  tel: '15906729802',
  company_account_id: '7013 0078 8015 0000 1899',
  company_bank: '上海浦东发展银行股份有限公司武汉水果湖支行',
  company_bank_name: '武汉祥文网络科技有限公司',
  alipay_account_id: '',
  alipay_name: '祥文网络',
  alipay_pic: '',
  section_id: 0,
  belonger_id: 0,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 